export default "__VITE_ASSET__CX$zDUPy__"